import { SelectOption } from '@shared/components';

export const getOptionsFromEnums = <T extends string>(
  enumObj: Record<string, T>,
  labelsObj: Record<T, string>,
): SelectOption[] => {
  return Object.values(enumObj).map((value) => ({
    label: labelsObj[value],
    value: value,
  }));
};
